import { createFileRoute } from "@tanstack/react-router";
import { UserListView } from "@/features/users/UsersListView/UserListView";

export const Route = createFileRoute("/users")({
	component: UserListView,
});
